module.exports = __webpack_public_path__ + "static/media/claas-shp.3d1f6a5c.png";